module.exports = __webpack_public_path__ + "/images/ico-nav-list.8abc1a6.svg";